<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <path
            d="M7.99988 1.3999C7.66851 1.3999 7.39988 1.66853 7.39988 1.9999C7.39988 2.33127 7.66851 2.5999 7.99988 2.5999C10.9822 2.5999 13.3999 5.01756 13.3999 7.9999C13.3999 10.9822 10.9822 13.3999 7.99988 13.3999C5.01755 13.3999 2.5999 10.9822 2.5999 7.9999C2.5999 7.66853 2.33127 7.3999 1.9999 7.3999C1.66853 7.3999 1.3999 7.66853 1.3999 7.9999C1.3999 11.645 4.35481 14.5999 7.99988 14.5999C11.6449 14.5999 14.5999 11.645 14.5999 7.9999C14.5999 4.35482 11.6449 1.3999 7.99988 1.3999Z"
            fill="currentColor"
        />
        <path
            d="M6.31897 2.19979C6.46 2.53989 6.29863 2.92994 5.95852 3.07097C5.61842 3.21201 5.22837 3.05063 5.08733 2.71053C4.9463 2.37042 5.10767 1.98038 5.44778 1.83934C5.78788 1.6983 6.17793 1.85968 6.31897 2.19979Z"
            fill="currentColor"
        />
        <path
            d="M4.22865 3.28583C4.489 3.54618 4.489 3.96829 4.22865 4.22863C3.9683 4.48898 3.54619 4.48899 3.28584 4.22864C3.02549 3.96829 3.02549 3.54618 3.28584 3.28583C3.54619 3.02548 3.9683 3.02548 4.22865 3.28583Z"
            fill="currentColor"
        />
        <path
            d="M2.71054 5.08733C3.05065 5.22836 3.21202 5.61841 3.07099 5.95851C2.92995 6.29862 2.53991 6.46 2.1998 6.31897C1.8597 6.17793 1.69832 5.78789 1.83936 5.44778C1.98039 5.10767 2.37044 4.94629 2.71054 5.08733Z"
            fill="currentColor"
        />
        <path
            d="M7.66654 4.3999C7.99791 4.3999 8.26654 4.66853 8.26654 4.9999V8.08479L9.74063 9.55889C9.97495 9.7932 9.97495 10.1731 9.74063 10.4074C9.50632 10.6417 9.12642 10.6417 8.89211 10.4074L7.2422 8.7575C7.12251 8.63781 7.06396 8.48014 7.06655 8.32329V4.9999C7.06655 4.66853 7.33518 4.3999 7.66654 4.3999Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: 'history-icon',
    props: {
        width: {
            type: [String, Number],
            default: 16,
        },
        height: {
            type: [String, Number],
            default: 16,
        },
        color: {
            type: String,
            default: 'text-content-basic-1',
        },
    },
};
</script>

